import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full text-print-base" }
const _hoisted_2 = { class: "print-mb2" }
const _hoisted_3 = { class: "font-bold" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode()
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Дата", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode()
const _hoisted_7 = { class: "font-bold" }
const _hoisted_8 = { class: "grid-2 print-mb2" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Платник: ")
const _hoisted_10 = { class: "font-bold" }
const _hoisted_11 = { class: "break-inside-avoid" }
const _hoisted_12 = { class: "font-bold" }
const _hoisted_13 = { class: "print-mb3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Сума до сплати:", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "grid-3" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Підпис:"),
  /*#__PURE__*/_createElementVNode("div", null, "ФОП Федічкін О.В.")
], -1)

import { RepairOrderClosedResource } from '@shared/resources/repair-order';
import { START_DOCUMENT_NUMBER } from 'client/src/components/print/constants';
import { timestampToDate } from 'client/src/helpers/datetime';
import { PrintTable, PrintTableColumn } from '../components/table'
import { computed } from 'vue';
import { coinsFormat, floatFormat } from '@shared/helpers/data-converters/number-converters';
import { useI18n } from 'vue-i18n';
import { QtyUnitNameMap } from '@shared/types/qty-unit';
import { numberInWords } from '../helpers/number-in-words';
import Creds from './partials/Creds.vue';
import { countItemPrice, countSum } from '@shared/helpers/sum';

interface Props {
  order: RepairOrderClosedResource;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PrintInvoiceOrderNew',
  props: {
    order: null
  },
  setup(__props: any) {

const props = __props as {
  order: RepairOrderClosedResource;
}

const { t } = useI18n();



const rows = computed(() => {
  const items = props.order.items.filter((item) => item.isItem);
  return items.map((item, index) => {
    return {
      index: index + 1,
      name: item.name,
      unit: t(`common.units.${QtyUnitNameMap[item.qtyType]}`),
      qty: floatFormat(item.qty),
      price: coinsFormat(item.price),
      sum: coinsFormat(countItemPrice(item)),
    };
  });
});

const sum = computed(() => countSum(rows.value));

const columns = computed<PrintTableColumn[]>(() => {
  return [
    {
      title: '№',
      data: 'index',
    },
    {
      title: 'Найменування',
      data: 'name',
    },
    {
      title: 'Один.вим.',
      data: 'unit',
    },
    {
      title: 'К-сть',
      data: 'qty',
    },
    {
      title: 'Ціна без ПДВ',
      data: 'price',
    },
    {
      title: 'Сума без ПДВ',
      data: 'sum',
    },
  ];
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, [
        _createElementVNode("span", _hoisted_3, "Накладна № " + _toDisplayString(__props.order.id + _unref(START_DOCUMENT_NUMBER)), 1),
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(timestampToDate)( __props.order.date )), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(Creds, { "hide-title": "" }),
      _createElementVNode("div", null, [
        _createElementVNode("p", null, [
          _hoisted_9,
          _createElementVNode("span", _hoisted_10, _toDisplayString(__props.order.client.name), 1)
        ])
      ])
    ]),
    _createVNode(_unref(PrintTable), {
      columns: _unref(columns),
      rows: _unref(rows),
      class: "print-mb"
    }, null, 8, ["columns", "rows"]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, "Всього без ПДВ " + _toDisplayString(_unref(sum)), 1),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createTextVNode(" " + _toDisplayString(_unref(coinsFormat)(_unref(sum))) + " (" + _toDisplayString(_unref(numberInWords)(Number(_unref(sum)))) + ")", 1)
      ]),
      _hoisted_15
    ])
  ]))
}
}

})